enum GapVehiclePaymentTypeEnum {
  hirePurchase = 'GapVehiclePaymentType.HirePurchase',
  pcpPurchase = 'GapVehiclePaymentType.PersonalContractPurchase',
}
export default GapVehiclePaymentTypeEnum
